<template>
  <div style="{'min-width':size}">
    <v-avatar :size="size">
      <img :src="user && user.photoURL" alt="" />
    </v-avatar>
    <div class="username capitalize" v-if="showName">{{ displayName }}</div>
  </div>
</template>

<script>
import { users } from "@/db";
// TODO: move userCache to db
const userCache = {};
export default {
  name: "HiAvatar",
  props: {
    uid: {
      type: String
    },
    size: {
      default: 45
    },
    showName: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      user: null
    };
  },
  // firestore: {
  //   user: collections.users.doc(this.uid)
  // }
  computed: {
    displayName() {
      if (!this.user) return;

      if (this.user.name) {
        let name = this.user.name;
        if (this.user.surname) {
          name += "." + this.user.surname.substr(0, 1).toUpperCase();
        }
        // console.log(name);
        return name;
      } else {
        return this.user.displayName;
      }
      // return this.users
      //   .filter(user => !!user.uid)
      //   .find(user => user.uid === this.userId);
    }
  },
  watch: {
    uid: {
      immediate: true,
      handler(id) {
        // console.log("id change " + id);
        if (!id) return;
        // console.log("userid" + id);
        // this.$bind("user", collections.users.doc(id));
        if (userCache[id]) {
          this.user = userCache[id];
          return;
        }
        users.getUser(id).then(user => {
          userCache[id] = user;
          // console.log(user);
          this.user = user;
        });
      }
    }
  }
};
</script>

<style>
.username {
  font-size: 9px;
  font-weight: bold;
  color: #999999;
  text-align: center;
}
</style>
